import { get } from 'lodash';
import { cinemasFetch, configFetch, modalsFetch, statesFetch } from '../actions/creators';
import * as actions from '../actions/types';
import { getBootstrapConfig, getCinemas, getModals, getSelectedCinema, getStates } from '../reducers';
import { getReferralFromUrl, getScopesFromUrl, REFERRAL_SCOPES, setReferralCookie } from '../utils/referral';

export const commonMiddleware = ({ getState, dispatch }) => next => async action => {
    // pre(action, getState, dispatch);
    next(action);
    post(action, getState, dispatch);
};

function post(action, getState, dispatch) {
    switch (action.type) {
        case actions.APP_LOADED: return onAppLoaded(action, getState, dispatch);
        case actions.CONFIG_FETCH_SUCCESS: return onConfigLoaded(action, getState, dispatch);
        case actions.CHANGE_PREFERRED_CINEMA: return onPreferredCinemaChange(action, getState, dispatch);
    }
}

function handleReferralFromUrl(config) {
    const ref = getReferralFromUrl();
    const scopes = getScopesFromUrl();
    const timeout_minutes = get(config, 'referral_attribution.timeout_minutes', null);
    const validScopes = REFERRAL_SCOPES && Object.values(REFERRAL_SCOPES) || [];
    
    if (!ref || !scopes.length || !timeout_minutes) {
        return;
    }
    scopes.forEach(scope => {
        if (validScopes.includes(scope)) {
            setReferralCookie(ref, scope, timeout_minutes);
        }
    });
}

function onConfigLoaded(action, getState, dispatch) {
    const config = action.config;
    handleReferralFromUrl(config);
}

function onAppLoaded(action, getState, dispatch) {
    const state = getState();
    const config = getBootstrapConfig(state);
    const states = getStates(state);
    const cinemas = getCinemas(state);
    const modals = getModals(state);
    
    if (!Object.keys(config).length) {
        dispatch(configFetch());
    } else {
        onConfigLoaded({ config }, getState, dispatch);
    }
    if (!states.length) dispatch(statesFetch());
    if (!cinemas.length) dispatch(cinemasFetch());
    if (null === modals) dispatch(modalsFetch());

    onPreferredCinemaChange(action, getState, dispatch);
}

function onPreferredCinemaChange(action, getState, dispatch) {
    const state = getState();
    const cinema = getSelectedCinema(state);

    setCinemaTheme(cinema);
}

export function setCinemaTheme(cinema) {
    const isMarket = cinema && cinema.market === true;
    const isPlatinum = cinema && cinema.platinum === true;

    if (isMarket) {
        document.body.classList.add('theme-market');
        document.body.classList.remove('theme-platinum');
        document.body.classList.remove('theme-traditional');
    } else if (isPlatinum) {
        document.body.classList.remove('theme-market');
        document.body.classList.add('theme-platinum');
        document.body.classList.remove('theme-traditional');
    } else {
        document.body.classList.remove('theme-market');
        document.body.classList.remove('theme-platinum');
        document.body.classList.add('theme-traditional');
    }
}

export default commonMiddleware;